export const styles = {
  infoBox: {
    display: "flex",
    alignItems: "center",
    backgroundColor: "#FEECEB",
    padding: "12px",
    marginBottom: "24px"
  },
  iconContainer: {
    width: "40px",
    height: "40px",
    backgroundColor: "#E6F5FC",
    borderRadius: "4px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginRight: "8px"
  },
  infoText: {
    lineHeight: 1.5,
    fontSize: "14px",
    color: "#212121"
  },
  organizationBox: {
    display: "flex",
    alignItems: "center",
    border: "1px solid #DDD",
    borderRadius: "4px",
    padding: "16px",
    marginBottom: "16px"
  },
  checkBoxBox: {
    marginBottom: "16px",
    display: "flex"
  }
};
